import { Box, Paper } from "@mui/material";
import { mesfColors } from "@/setup/ag-grid/mesf-theme";
import type { MillVisualizerData } from "./models/MillVisualizer";
import { KpiStrip } from "./parts/KpiStrip";
import { VisualizerHeader } from "./parts/VisualizerHeader";
import { VisualizerStage } from "./parts/VisualizerStage";

interface Props {
	data: MillVisualizerData;
	onStandClick?: (standId: string) => void;
}

// Layout policy: each child (stage and strip) is responsible for reserving
// its own PROPERTY_COLUMN_WIDTH-px slot at the left for its variant of the
// Pre-heating element. Stage renders a furnace-mouth visual aligned with
// the stand row; strip renders a small card aligned with the KPI cards.
// Single unified block was tested but visually merged the two sections;
// splitting reads better against the table below.
export const MillVisualizer = ({ data, onStandClick }: Props) => (
	<Paper
		variant="outlined"
		sx={{
			p: 1,
			borderColor: mesfColors.grey[200],
			bgcolor: mesfColors.background.paper,
		}}
	>
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				gap: 0.25,
			}}
		>
			<VisualizerHeader data={data} />
			<VisualizerStage data={data} onStandClick={onStandClick} />
			<KpiStrip stands={data.stands} />
		</Box>
	</Paper>
);
